<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table
      :data="contactHistory"
      style="width: 100%"
      :render-header="renderHeader"
      height="calc(100vh - 353px)"
      @sort-change="handleSort"
    >
      <el-table-column prop="tenantId" label="商户ID" align="left">
        <template slot-scope="scope">
          {{ scope.row.tenantId }}
        </template>
      </el-table-column>
      <el-table-column
        prop="timestamp"
        label="日期"
        align="left"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.timestamp | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="userJoinCount" label="参与人数" align="left">
        <template slot-scope="scope">
          {{ scope.row.userJoinCount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="incentiveAmount"
        label="奖励金额(USDT)"
        align="left"
      >
        <template slot-scope="scope">
          {{ scope.row.incentiveAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="extractedAmount"
        label="已提现金额(USDT)"
        align="left"
      >
        <template slot-scope="scope">
          {{ scope.row.extractedAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="inventiveLotteryCount"
        label="奖励卡券"
        align="left"
      >
        <template slot-scope="scope">
          {{ scope.row.inventiveLotteryCount }}
        </template>
      </el-table-column>
      <el-table-column prop="usedLotteryCount" label="已使用卡券" align="left">
        <template slot-scope="scope">
          {{ scope.row.usedLotteryCount }}
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div> -->
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import order from '@/assets/order.png'
import UserDetailDialog from 'components/userDetailDialog'
import { positionOrderList } from '@/common/publicApi'
import tip from '@/assets/partnerCenter/tip.png'
export default {
  name: 'ContactHistoryList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      order,
      tip,
      type: '',
      id: '',
      cacheRow: {},
      orderList: [],
      orderVisible: false,
      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
  },
  methods: {
    ...mapActions('closingCommission', ['addRemark']),
    // ...mapActions('statistics', ['getHistory']),

    ...mapMutations('closingCommission', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    ...mapMutations('statistics', ['setPagination', 'setOrderBy']),
    // getContactHistory() {
    //   this.getHistory()
    // },
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },

    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', { ...pagination })
    },

    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },
  },
  computed: {
    // ...mapGetters('user', ['contactHistory']),
    ...mapState(['userInfo']),
    ...mapState('statistics', [
      'pagination',
      'contactHistory',
      'totalCount',
      'orderBy',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.green {
  color: skyblue;
}
.red {
  color: #f54a45;
}
</style>
